import React from 'react';
import { useAuth } from '../contexts/AuthContext';

const SellerPendingApproval = () => {
  const { logout } = useAuth();
  
  const handleBrowseMarketplace = () => {
    // Force a page reload to trigger the auth check again
    window.location.href = '/marketplace';
  };

  const handleLogout = async () => {
    try {
      await logout();
      // Redirect to sign up page
      window.location.href = '/';
    } catch (error) {
      console.error('Error logging out:', error);
    }
  };

  return (
    <div className="min-h-screen bg-abiu-green-bg flex items-center justify-center px-4">
      <div className="bg-white rounded-xl shadow-lg p-8 max-w-md w-full text-center">
        <div className="mb-6">
          <div className="w-16 h-16 bg-yellow-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg className="w-8 h-8 text-yellow-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
            </svg>
          </div>
          <h1 className="text-2xl font-bold text-gray-900 mb-2">Profile Pending Approval</h1>
          <p className="text-gray-600 mb-6">
            Thank you for registering as a seller! Your profile is currently under review by our team.
          </p>
        </div>

        <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-6">
          <h3 className="font-semibold text-yellow-800 mb-2">What happens next?</h3>
          <ul className="text-sm text-yellow-700 space-y-1 text-left">
            <li>• Our team will review your business information</li>
            <li>• We'll verify your credentials and experience</li>
            <li>• You'll receive an email notification once approved</li>
            <li>• Approval typically takes 1-3 business days</li>
          </ul>
        </div>

        <div className="space-y-4">
          <div className="text-sm text-gray-600">
            <p className="mb-2">While you wait, you can:</p>
            <ul className="space-y-1 text-left">
              <li>• Browse the marketplace as a buyer</li>
              <li>• Learn about solar projects and requirements</li>
              <li>• Prepare your portfolio and certifications</li>
            </ul>
          </div>
        </div>

        <div className="mt-8 space-y-3">
          <button
            onClick={handleBrowseMarketplace}
            className="block w-full bg-abiu-green text-white font-semibold py-3 px-4 rounded-lg hover:bg-abiu-green-dark transition"
          >
            Browse Marketplace
          </button>
          <button
            onClick={() => window.location.reload()}
            className="block w-full bg-gray-100 text-gray-700 font-semibold py-3 px-4 rounded-lg hover:bg-gray-200 transition"
          >
            Check Approval Status
          </button>
          <button
            onClick={handleLogout}
            className="block w-full bg-red-100 text-red-700 font-semibold py-3 px-4 rounded-lg hover:bg-red-200 transition"
          >
            Sign Out
          </button>
        </div>

        <div className="mt-6 text-xs text-gray-400">
          <p>Need help? Contact us at support@abiu.earth</p>
        </div>
      </div>
    </div>
  );
};

export default SellerPendingApproval; 